import React from 'react';
import {useIntl} from 'react-intl';

import {IOrderStatusProps} from './IOrderStatus';
import messages from './messages';

const OrderStatus = ({status}: IOrderStatusProps) => {
	const intl = useIntl();

	return (
		<>{messages[status] ? intl.formatMessage(messages[status]) : status}</>
	);
};

export default OrderStatus;
